import React, { useEffect } from 'react'
import NotFoundSVG from './assets/404notfound.svg'
import {NavLink} from 'react-router-dom'

import './NotFound.css'

function NotFound() {
  useEffect(() => {
    document.title = "404 - Page Not Found"
  })
  return (
    <>
      <div className="center-div">
        <div className="sec-div-cen">
          <div className="svgPic">
            <img src={NotFoundSVG} alt="404 error"  width='400' className='logoerr'/>
          </div>
          <h1 className='my-5'><span>404</span> Page Not Found</h1>
          <p>The page that you are looking for is not found</p>
        <NavLink to='/'><button className='btn btn-outline-primary'>Back to Home</button></NavLink>
        </div>
      </div>
    </>
  )
}

export default NotFound